import controller from './movements.controller';
import template from './movements.html';

const posMovementsComponent = {
  restrict: 'E',
  bindings: {},
  controller,
  template
};

export default posMovementsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/dashboard/pos/movements/movements.component.js
 **/